var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 110,
    viewBox: "0 0 112 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 0.595703C25.1923 0.595703 0.222168 25.5658 0.222168 56.3735C0.222168 81.0075 16.2067 101.913 38.365 109.309C41.1463 109.829 42.1855 108.086 42.1855 106.619C42.1855 105.275 42.1243 100.904 42.1243 96.228C26.5982 99.5899 23.328 89.6569 23.328 89.6569C20.7912 83.208 17.1236 81.4965 17.1236 81.4965C12.0501 78.0429 17.4904 78.104 17.4904 78.104C23.0834 78.5013 26.0481 83.8499 26.0481 83.8499C31.0299 92.377 39.0986 89.9014 42.2771 88.4955C42.7662 84.889 44.2332 82.444 45.8225 81.0381C33.4444 79.6321 20.3939 74.8337 20.3939 53.47C20.3939 47.388 22.5639 42.4062 26.1398 38.4941C25.5591 37.0882 23.6641 31.4034 26.6899 23.732C26.6899 23.732 31.3661 22.2344 42.0326 29.4474C46.4949 28.2248 51.2627 27.583 56 27.583C60.7373 27.6136 65.5052 28.2248 69.9674 29.4474C80.6034 22.2344 85.2796 23.732 85.2796 23.732C88.3053 31.4034 86.4104 37.0882 85.8297 38.4941C89.4056 42.4062 91.5756 47.388 91.5756 53.47C91.5756 74.8949 78.5251 79.6016 66.1164 80.9769C68.1031 82.719 69.9063 86.1115 69.9063 91.3073C69.9063 98.7647 69.8451 104.786 69.8451 106.619C69.8451 108.117 70.8537 109.829 73.6656 109.309C95.8239 101.913 111.778 81.038 111.778 56.3735C111.778 25.5658 86.8077 0.595703 56 0.595703Z",
    fill: "#181616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.442c728c6dc852664e90bb63de81f3cd.svg";
export { ForwardRef as ReactComponent };